export const DOCUMENT_TYPE = {
    OFFER_LETTER: "Offer Letter",
    RELIEVING_LETTER: "Relieving Letter",
    EXPERIENCE_LETTER: "Experience Letter",
    APPOINTMENT_LETTER: "Appointment Letter",
    NURTURE_APPOINTMENT_LETTER: "Nurture Appointment Letter",
    APPRAISAL_LETTER: "Appraisal Letter",
    EXTENSION_LETTER: "Extension Letter",
    SECURITY_CHEQUE_DEPOSIT_LETTER: "Security Cheque Deposit Letter",
    NURTURE_SECURITY_CHEQUE_DEPOSIT_LETTER: "Nurture Security Cheque Deposit Letter",
    EMPLOYMENT_BOND_AGREEMENT_LETTER: "Bond Agreement Letter",
    EMPLOYEE_CONFIRMATION_LETTER: "Employee Confirmation Letter"
};